import React from 'react';
import { Link } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import { Alert, Form, Button } from 'react-bootstrap';
import { Input, FormActions, Checkbox, FormFileUpload } from '../../common/components/formControls';
import validators from '../../common/services/validators';
import { withTranslation } from 'react-i18next';
import Localizations from '../localization';

const SettingsForm = ({ franchiseeId, error, handleSubmit, pristine, submitting, submitSucceeded,
	isReadonly, hasSelectedUser, initialValues, lang, t }) => {
	const pictureData = initialValues && {
		url: initialValues.pictureUrl
	};
	let id = initialValues ? initialValues.id : 0;

	return (
		<Form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{submitSucceeded && pristine && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
			
			<Field name='firstName' component={Input} disabled={isReadonly} horizontal type='text' label={t('User_FirstName')} />
			<Field name='lastName' component={Input} disabled={isReadonly} horizontal type='text' label={t('User_LastName')} />
			<Field name='username' component={Input} disabled={isReadonly} horizontal required type='text' label={t('User_Username')} validate={validators.required} />
			<Field name='email' component={Input} disabled={isReadonly} horizontal required type='text' label={t('User_Email')} validate={[validators.required, validators.email]} />
			<Field name='pictureId' component={FormFileUpload} image disabled={isReadonly} horizontal label={t('Teacher_Photo')} initialData={pictureData} />
			<Field name='bio' component={Input} disabled={isReadonly} lang={lang} horizontal type='text' componentClass='textarea' rows={5} label={t('Teacher_Bio')} />
			{id > 0 && <Localizations entityId={id} rootName={'teachers'} propertyName={'Bio'} label={t('Teacher_Bio')} resourceName={`Teacher.${id}.Bio`} isHtml={false} componentClass='textarea' rows={5} isReadonly={isReadonly} />}

			<Field name='enabled' component={Checkbox} disabled={isReadonly} horizontal label={t('User_Enabled')} normalize={(v) => { return !!v }} />
			<FormActions horizontal>
				<Link to={`/franchisees/${franchiseeId}/teachers`} className='btn btn-default'>{t('Common_BackToList')}</Link>
				<Button type='submit' disabled={pristine && hasSelectedUser !== true || submitting} bsStyle='primary'>{t('Common_Save')}</Button>
			</FormActions>
		</Form>
	);
};

export default reduxForm({ form: 'teacher', enableReinitialize: true })(withTranslation()(SettingsForm));
